import { Box, styled } from "@mui/material";

export const ResultsContainer = styled(Box)(({ theme }) => ({
  padding: "1.5rem 1rem 0",
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    padding: "2rem 2rem 0",
  },
}));

export const PostsContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "2.5rem",
    alignSelf: "stretch",
  },

  [theme.breakpoints.up("lg")]: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "2.5rem",
    alignSelf: "stretch",
  },
}));

export const PostCardLayout = styled("div")(({ theme }) => ({
  display: "grid",
  width: "100%",

  // Apply consistent spacing using theme spacing
  gap: theme.spacing(4),

  // Use theme breakpoints for responsive design
  [theme.breakpoints.up("xs")]: {
    gridTemplateColumns: "1fr",
    gap: theme.spacing(2.5),
  },
  // [theme.breakpoints.only("sm")]: {
  //   gridTemplateColumns: "1fr",
  //   gap: theme.spacing(3),
  // },
  [theme.breakpoints.up("md")]: {
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: theme.spacing(3.5),
  },
  [theme.breakpoints.up("lg")]: {
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: theme.spacing(4.5),
  },
}));

export const PaginationContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "center",
  gap: "2.5rem",
  alignSelf: "stretch",
}));
